import { forwardRef, InputHTMLAttributes } from 'react';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  className?: string;
};

export const EditorHeaderTitleInput = forwardRef<HTMLInputElement, Props>(
  function EditorHeaderTitleInput({ className, ...rest }) {
    const inputProps = {
      ...rest,
    };
    return (
      <input
        size={Math.max(8, Math.min(String(inputProps.value)?.length || 0, 50))}
        placeholder="Untitled"
        {...inputProps}
        className={`w-auto p-2 text-sm text-gray-700 outline-none focus:border focus:rounded-md focus:border-gray-300 focus:shadow-xs placeholder:text-gray-500 min-w-15 disabled:bg-transparent ${className}`}
      />
    );
  }
);
